import { Stack, Typography, useTheme } from '@mui/material';
import { useAnimation, m } from 'framer-motion';
import Iconify from '../iconify';

export const PayNowButton = () => {
  const controls = useAnimation();
  const theme = useTheme();

  const scrollTo = () => {
    const section = document.querySelector('#payment-disclaimer');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  //   useEffect(() => {
  //     scrollYProgress.onChange(progress => {
  //       if (progress > 0.1) {
  //         controls.start({ opacity: 1, pointerEvents: 'auto' });
  //       } else {
  //         controls.start({ opacity: 0, pointerEvents: 'none' });
  //       }
  //     });
  //   }, [scrollYProgress, controls]);

  return (
    <m.div onClick={scrollTo} initial={{ opacity: 1 }} animate={controls}>
      <Stack
        zIndex={10}
        sx={{
          position: 'fixed',
          right: 24,
          bottom: 24,
          //   width: 50,
          height: 50,
          bgcolor: theme.palette.background.paper,
          borderRadius: '16px',
          justifyContent: 'center',
          alignItems: 'center',
          boxShadow: theme.customShadows.info,
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'row',
          p: 1,
          py: '4px',
          visibility: {
            xs: 'visible',
            sm: 'hidden',
          },
        }}
      >
        <Iconify icon="mdi:dollar" width={24} />
        <Typography variant="subtitle2">Pay Now</Typography>
      </Stack>
    </m.div>
  );
};
